import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ReactModal from "react-modal";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { submitAction } from "../../redux/action";
import { Formik } from "formik";
import {validateSendQueryPopup } from "../../constant/validation";
import { onlyNumber } from "../../constant/utils";

const SendQueryModal = ({ modalIsOpen, setModalIsOpen, test, code, lab }: any) => {
  ReactModal.setAppElement("body");
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const cityData = useSelector((state: any) => state.dashboard.cityAll);
  const [initialValue, setInitialValue] = useState({
    Name: "",
    Email: "",
    Mobile: "",
    CityId: "",
    Message: "",
    UtmSource: "",
    UtmMedium: "",
    UtmCampaign: "",
    Checkbox: false
  });
  const customStyles: any = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      backgroundColor: "#fff",
      minWidth: "300px",
      minHeight: "300px",
      maxWidth: "calc(100vw - 1rem)",
      maxHeight: "calc(100vh - 1rem)",
      overflow: "auto",
    },
  };

  useEffect(() => {
    setInitialValue({ ...initialValue, Message: code });
  }, [code]);

  const handleSubmit = (values: any) => {
    let val: any = { ...values };
    val.SourceUrl = window.location.href;
    const urlParams = new URLSearchParams(window.location.search);
    val.UtmSource = urlParams.get("utm_source");
    val.UtmMedium = urlParams.get("utm_medium");
    val.UtmCampaign = urlParams.get("utm_campaign");
    if (lab) {
      val.LabName = code;
    } else if (test) {
      val.TestCode = code;
    } else {
      val.PackageCode = code;
    }
    dispatch(submitAction.submitEnquiryAction(val, history));
    setModalIsOpen(false);
  };
  return (
    <ReactModal isOpen={modalIsOpen} style={customStyles} onRequestClose={() => setModalIsOpen(false)}>
      <div className="model-header">
        <span className="model-btn pointer" onClick={() => setModalIsOpen(false)}>
          x
        </span>
      </div>
      <>
        <Formik
          initialValues={initialValue}
          enableReinitialize={true}
          validationSchema={validateSendQueryPopup}
          onSubmit={(val: any) => {
            handleSubmit(val);
          }}
          render={({ values, handleChange, errors, touched, handleBlur, handleSubmit, setFieldValue }) => (
            <form onSubmit={handleSubmit}>
              <div className="infobox_wrapper">
                <h3 className="mr-10">{"GET A CALL BACK"}</h3>
                <div className="ln-1 mr-10">{t("neurology_form_note")}</div>
                <div className="form-group">
                  <input
                    type="text"
                    name="Name"
                    className="form-control"
                    placeholder={t("name")}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values?.Name}
                  />
                  {touched?.Name && errors?.Name && <span className="error_message">{t(errors?.Name)}</span>}
                </div>
                <div className="form-group">
                  <input
                    type="text"
                    name="Mobile"
                    className="form-control"
                    placeholder={t("mobile_number")}
                    onKeyPress={onlyNumber}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values?.Mobile}
                  />
                  {touched?.Mobile && errors?.Mobile && <span className="error_message">{t(errors?.Mobile)}</span>}
                </div>
                <div className="form-group">
                  <select
                    className="form-control"
                    name="CityId"
                    id="CityId"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values?.CityId}
                  >
                    <option value="">{t("city")}*</option>
                    {cityData &&
                      cityData.length > 0 &&
                      cityData?.map((item: any, i: any) => (
                        <option value={item?.Id} key={i} className="text-uppercase">
                          {t(item?.Name)}
                        </option>
                      ))}
                  </select>
                  {touched?.CityId && errors?.CityId && <span className="error_message">{t(errors?.CityId)}</span>}
                </div>
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder={t("email")}
                    name="Email"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values?.Email}
                  />
                  {touched?.Email && errors?.Email && <span className="error_message">{errors?.Email}</span>}
                </div>
                <div className="form-group">
                  <textarea
                    className="form-control"
                    placeholder={t("message")}
                    name="Message"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values?.Message}
                  ></textarea>
                  {touched?.Message && errors?.Message && <span className="error_message">{t(errors?.Message)}</span>}
                </div>
                <div className="d-flex for-check-style">
                  <input type="checkbox" name="Checkbox" onChange={handleChange} onBlur={handleBlur} id="checkbox_id" />
                  <label className="mx-2" htmlFor="checkbox_id">
                    By clicking you accept to the{" "}
                    <a className="text-info" href="https://oncquestlabs.com/terms-condition">
                      terms and conditions
                    </a>{" "}
                    and the{" "}
                    <a className="text-info" href="https://oncquestlabs.com/privacy-policy">
                      Privacy Policy.
                    </a>
                  </label>
                </div>
                <div>
                  {touched?.Checkbox && errors?.Checkbox && <span className="error_message">{errors?.Checkbox}</span>}
                </div>
                <button type="submit" className="book--hexagon active">
                  <span>
                    {t("submit_btn")}
                    <i className="fa fa-long-arrow-right ml-20" aria-hidden="true"></i>
                  </span>
                </button>
              </div>
            </form>
          )}
        />
      </>
    </ReactModal>
  );
};

export default SendQueryModal;
